import { render, staticRenderFns } from "./cardInform.vue?vue&type=template&id=51ee7330&scoped=true&"
import script from "./cardInform.vue?vue&type=script&lang=js&"
export * from "./cardInform.vue?vue&type=script&lang=js&"
import style0 from "./cardInform.vue?vue&type=style&index=0&id=51ee7330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ee7330",
  null
  
)

export default component.exports